import { useContext, useMemo } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { VoicemailNotificationLogDto } from "@/openapi";
import { ChildrenContext } from "@/context/children";
import { NotificationBody, NotificationTitle } from "./common";

interface Props {
  notification: VoicemailNotificationLogDto;
}

export const Voicemail = ({ notification }: Props) => {
  const { t } = useTranslation("notifications");
  const { data: children } = useContext(ChildrenContext);

  const childName = useMemo(
    () => children?.find((child) => child.id === notification.childrenId)?.firstName,
    [children, notification.childrenId],
  );

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", rowGap: 1 }}>
      <NotificationTitle clamp={false}>{t("newPinwheelHomeVoicemail")}</NotificationTitle>
      <NotificationBody clamp={false}>{t("childReceivedNewVoicemail", { childName })}</NotificationBody>
    </Box>
  );
};
